import { render, staticRenderFns } from "./ReviewNewBookAndChapter.vue?vue&type=template&id=17b1f39a"
import script from "./ReviewNewBookAndChapter.vue?vue&type=script&lang=js"
export * from "./ReviewNewBookAndChapter.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports